var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('iframe',{class:_vm.$style.preview,attrs:{"srcdoc":_vm.html,"allow":"fullscreen","height":"100%","sandbox":"allow-scripts allow-popups allow-same-origin","title":"Email preview","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }